import React from 'react';

interface CardProps {
  suit: 'hearts' | 'diamonds' | 'clubs' | 'spades';
  rank: 'A' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | 'J' | 'Q' | 'K';
}

function Card({ suit, rank }: CardProps) {
  const suitSymbols = {
    hearts: '♥',

    diamonds: '♦',

    clubs: '♣',

    spades: '♠',

  };

  const suitColors = {
    hearts: '#e74c3c',
    diamonds: '#e74c3c',
    clubs: '#2c3e50',
    spades: '#2c3e50',
  };

  return (
    <div
      style={{
        width: '80px',
        height: '120px',
        border: '2px solid #333',
        borderRadius: '8px',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px',
        fontWeight: 'bold',
        fontSize: '20px',
        color: suitColors[suit],
        boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
      }}
    >
      <span>{rank}</span>
      <span style={{ fontSize: '32px' }}>{suitSymbols[suit]}</span>
      <span>{rank}</span>
    </div>
  );
}

export default Card;